var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconConnectivityProblem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.86 16.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #667085;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.55,
    y1: 2.75,
    x2: 16.94,
    y2: 15.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.42,2.15s1.14-1.15,3.04-1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.62,13.47H3.87s-2.87.16-2.87-2.99c0-2.83,3.14-3.16,3.14-3.16,0,0-.18-1.31.42-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.18,11.9s.68-.74.68-2.17c0-2.83-3.14-3.16-3.14-3.16,0,0,.6-5.57-5.26-5.57"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnectivityProblem);
export default __webpack_public_path__ + "static/media/icon_connectivity_problem.3722345d2350b603f8bb0a0c520a0b20.svg";
export { ForwardRef as ReactComponent };